/**
 * Channel Plugin Registry.
 *
 * Para adicionar um novo canal:
 *   1. Crie pasta channels/plugins/MeuCanal/ implementando o contract de types.js
 *   2. Importe o plugin aqui
 *   3. Adicione ao array CHANNEL_REGISTRY
 *
 * A ordem aqui define a ordem de exibição no grid.
 */

import { validateChannelPlugin } from './types';

import WhatsAppCloudApiChannel from './plugins/WhatsAppCloudApi';
import WhatsAppWahaChannel from './plugins/WhatsAppWaha';
import InstagramChannel from './plugins/Instagram';
import MessengerChannel from './plugins/Messenger';
import SiteWidgetStubChannel from './plugins/SiteWidgetStub';

const _registry = [
  WhatsAppCloudApiChannel,
  WhatsAppWahaChannel,
  InstagramChannel,
  MessengerChannel,
  SiteWidgetStubChannel,
];

// Valida em dev — ajuda a pegar plugin mal-formado cedo
if (process.env.NODE_ENV !== 'production') {
  _registry.forEach(validateChannelPlugin);
}

export const CHANNEL_REGISTRY = _registry;

export function getChannelById(id) {
  return CHANNEL_REGISTRY.find((c) => c.id === id) || null;
}

export function getAvailableChannels() {
  return CHANNEL_REGISTRY.filter((c) => c.isAvailable);
}

export function getStubChannels() {
  return CHANNEL_REGISTRY.filter((c) => !c.isAvailable);
}
